module.exports = __webpack_public_path__ + "static/media/grey10.56324144.png";